import classnames from 'classnames';
import React from 'react';
import { GoInfo } from 'react-icons/go';
import { Tooltip as ReactStrapTooltip } from 'reactstrap';

import Tooltip from './Tooltip';

const InfoTooltip = ({ onClick, className, ...props }) => (
  <>
    <GoInfo
      onClick={onClick}
      className={classnames('infoTooltip', className)}
      id={props.target}
    />
    <Tooltip placement={props.placement} {...props}>
      {props.children}
    </Tooltip>
  </>
);

InfoTooltip.propTypes = ReactStrapTooltip.propTypes;

InfoTooltip.defaultProps = {
  placement: 'right',
  onClick: () => {},
};

export default InfoTooltip;
